import React from 'react';
import Slider from 'react-slick';
import { css } from '@emotion/core';
import ArrowLeftIcon from '@material-ui/icons/ArrowLeft';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';

import useCheckRWD from 'client/game_photoFrameComposite/FrameComposite/useCheckRWD';

function FrameSlider({
    frameSize = 80,
    frameList,
    onFrameClick = () => {},
    nextStep = false,
    ratioFrame = false,
    style = false
}) {
    const frameTotalCount = frameList.length;
    const rwd = useCheckRWD();
    const slidesToShow = (() => {
        if (rwd === 'xsm' && frameTotalCount > 2) {
            return 3;
        }
        if (frameTotalCount > 8) {
            return 8;
        }
        if (frameTotalCount > 4) {
            return 5;
        }
        return frameTotalCount;
    })();

    const slideWrapperStyle = (slideCapacityNumber => {
        if (rwd === 'xsm' && frameTotalCount > 2) {
            return `max-width: ${frameSize * 3}px;`;
        }

        if (frameTotalCount > 8) {
            return `max-width: ${frameSize * 8}px;`;
        }

        if (frameTotalCount > 4) {
            return `max-width: ${frameSize * 5}px;`;
        }

        return `max-width: ${frameSize * slideCapacityNumber}px;`;
    })(slidesToShow);

    return (
        <div css={[carouselContainerStyle(frameSize, !nextStep), slideWrapperStyle, css(style)]}>
            <Slider {...carouselSettings(slidesToShow, !nextStep)} key={frameList}>
                {frameList.map(({ uuid, value, settings }) => {
                    return (
                        <div
                            key={uuid}
                            onClick={() => {
                                if (nextStep) {
                                    return;
                                }
                                onFrameClick({ uuid, value });
                            }}
                            style={{ width: frameSize }}
                            css={frameStyle}
                        >
                            <div
                                css={imgContentStyle(
                                    frameSize,
                                    settings?.mode === 'image',
                                    settings?.mode === 'color',
                                    settings?.colorBackGround
                                )}
                            >
                                {settings?.mode !== 'color' && (
                                    <img
                                        src={value}
                                        alt={uuid}
                                        css={
                                            ratioFrame ? commentImgStyle : frameImgStyle(frameSize)
                                        }
                                    />
                                )}
                                {settings?.colorMask && (
                                    <div css={imgMaskColor(settings?.colorMask)}></div>
                                )}
                            </div>
                        </div>
                    );
                })}
            </Slider>
        </div>
    );
}

export default FrameSlider;

function NextArrow(props) {
    const { className, style, onClick } = props;
    return (
        <ArrowRightIcon
            className={className}
            style={{ ...style, color: 'black' }}
            onClick={onClick}
        />
    );
}

function PrevArrow(props) {
    const { className, style, onClick } = props;
    return (
        <ArrowLeftIcon
            className={className}
            style={{ ...style, color: 'black' }}
            onClick={onClick}
        />
    );
}
function carouselSettings(count, showArrowIcon) {
    return {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: count,
        slidesToScroll: count,
        initialSlide: 0,
        variableWidth: true,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        arrows: showArrowIcon
    };
}

const carouselContainerStyle = (frameSize, showArrowIcon) => css`
    margin-top: 8px;
    margin-bottom: 8px;
    width: 100%;
    & .slick-track {
        display: flex;
        justify-content: center;
        align-items: center;
        height: ${frameSize}px;
    }
    & .slick-initialized {
        & .slick-slide {
            display: flex;
            justify-content: center;
            align-items: center;
            box-sizing: border-box;
            &:hover {
                border: 2px solid #212121;
                border-radius: 8px;
                cursor: ${showArrowIcon ? 'pointer' : 'not-allowed'};
            }
        }
    }
    & .slick-arrow {
        &.slick-disabled {
            opacity: 0.4;
            cursor: not-allowed;
        }
        color: #000;
        border-radius: 50%;
    }
    & .slick-prev {
        left: -30px;
    }
    & .slick-next {
        right: -30px;
    }
`;

const frameStyle = css`
    vertical-align: middle;
`;

const imgMaskColor = maskColor => css`
    width: 100%;
    height: 100%;
    background-color: ${maskColor};
    position: absolute;
    top: 0;
    left: 0;
`;

const frameImgStyle = frameSize => css`
    max-width: ${frameSize - 10}px;
    max-height: ${frameSize - 10}px;
`;

const commentImgStyle = css`
    width: 100%;
    height: 100%;
`;

const imgContentStyle = (frameSize, imageMode, colorMode, colorBackGround) => css`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: ${colorMode ? frameSize - 8 : frameSize}px;
    height: ${colorMode ? frameSize - 8 : frameSize}px;
    padding: ${imageMode ? 4 : 0}px;
    max-width: 100%;
    max-height: 100%;
    background: ${colorMode ? colorBackGround : 'transparent'};
`;
